export default __webpack_public_path__ + "static/media/yellow_star.f7cbb5b6.svg";